'use client'

import { ClockRegular } from '@/icons/web/regular/clock'
import { type Product } from '@/lib/generated/graphql'
import { countdownTextCalculator } from '@/utils/time/count-down-text-calculator'
import { useEffect, useState } from 'react'

const useProductDetailsTimer = (product?: Product | null) => {
  const [timeLeft, setTimeLeft] = useState(() =>
    product?.__typename === 'product'
      ? countdownTextCalculator(
          product?.product_hideDate,
          product?.product_startDate,
          product?.product_endDate,
          'Offer',
          true,
        )
      : '',
  )

  useEffect(() => {
    if (product?.__typename === 'product') {
      setTimeLeft(
        countdownTextCalculator(
          product?.product_hideDate,
          product?.product_startDate,
          product?.product_endDate,
          'Offer',
          true,
        ),
      )
    }
  }, [product])

  useEffect(() => {
    let interval: NodeJS.Timer
    if (product && product.__typename === 'product') {
      interval = setInterval(() => {
        const newText = countdownTextCalculator(
          product?.product_hideDate,
          product?.product_startDate,
          product?.product_endDate,
          'Offer',
          true,
        )
        if (timeLeft !== newText) {
          setTimeLeft(newText)
        }
      }, 60_000)
    }
    return () => {
      if (interval != null) {
        // @ts-expect-error silly typescript

        clearInterval(interval)
      }
    }
  }, [product, timeLeft])

  return timeLeft
}

export default ({ product }: { product: Product }) => {
  const timerText = useProductDetailsTimer(product)

  return (
    <span
      className='my-4 flex items-center text-sm font-medium'
      data-testid='product-details-date'
    >
      {timerText === '' ? (
        ''
      ) : (
        <>
          <ClockRegular className='mr-1' /> {timerText}
        </>
      )}
    </span>
  )
}
